import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"search\">\n<path d=\"M11,20c-5,0-9-4-9-9c0-5,4-9,9-9c5,0,9,4,9,9C20,16,16,20,11,20z M11,4c-3.9,0-7,3.1-7,7c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7\n\tC18,7.1,14.9,4,11,4z\" />\n<path d=\"M21,22c-0.3,0-0.5-0.1-0.7-0.3l-4.3-4.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l4.3,4.3c0.4,0.4,0.4,1,0,1.4\n\tC21.5,21.9,21.3,22,21,22z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol